import { cn as e } from "../shared/utils.js";
import { forwardRef as t } from "react";
import { jsx as n } from "react/jsx-runtime";
import { cva as r } from "class-variance-authority";
import { Input as i } from "@base-ui/react/input";
//#region src/input/input.tsx
var a = r([
	"flex w-full items-center rounded-md input-ring transition-base bg-field-bg-primary text-text-primary outline-none text-base px-3 text-ellipsis",
	"placeholder:text-text-tertiary",
	"data-disabled:bg-field-bg-disabled data-disabled:text-text-disabled data-disabled:placeholder:text-text-disabled data-disabled:cursor-not-allowed"
], {
	variants: { size: {
		sm: "h-8",
		md: "h-10"
	} },
	defaultVariants: { size: "md" }
}), o = t(({ className: t, size: r, ...o }, s) => /* @__PURE__ */ n(i, {
	ref: s,
	className: e(a({ size: r }), t),
	"data-slot": "input",
	"data-testid": "input",
	"data-size": r,
	...o
}));
o.displayName = i.displayName;
//#endregion
export { o as Input, a as inputVariants };
